// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__16fMh","spinning":"Spinner_spinning__2xrD3"};